export enum AdminCatalogItemApiTag {
  Item = 'CatalogItem',
  ItemList = 'CatalogItemList',
}

export const adminCatalogItemApiTags = Object.values(AdminCatalogItemApiTag);
